import postAPI from './postAPI.js'

export default async function postUpdateField(fieldData) {
    const data = await postAPI('admin/taskflows/steps/fields/update', fieldData);
    return data;
}
